import type { FeatureFlag } from '@/feature-flags/FeatureEvaluator';

const cacheKey = 'entity_portal_feature_flags_cache';

function parse(value: string): FeatureFlag[] {
  try {
    return JSON.parse(value) as FeatureFlag[];
  } catch {
    return [];
  }
}

export const featureFlagCache = {
  read(): FeatureFlag[] {
    const cached = window.localStorage.getItem(cacheKey);

    if (!cached) {
      return [];
    }

    return parse(cached);
  },

  write(flags: FeatureFlag[]): void {
    window.localStorage.setItem(cacheKey, JSON.stringify(flags));
  },

  clear(): void {
    window.localStorage.removeItem(cacheKey);
  },
};
